import { html, render } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import logo from "@docroot/public/img/escapio_logo_e_blank.svg";

customElements.define(
	"esc-escapio-deal-badge",
	class extends HTMLElement {
		connectedCallback() {
			const template = html`${logo}${translate("escapio_deal_badge_text")}`;
			render(template, this);
		}
	},
);
